import styled, { createGlobalStyle } from 'styled-components';
import { QUALITY_MARK_ASPECT_RATIO, breakpoints } from 'config/config';

export const GlobalStyle = createGlobalStyle`
  .buy-latvia-food {
    display: none !important;
  }
`;

export const StyledPriceAvailabilityCard = styled.div`
  flex-grow: 1;
  border: 1px solid ${({ theme }) => theme.lightGrey};
  border-radius: 5px;
  padding: 20px 24px;
  font-size: 16px;

  .price-availability-title {
    margin-bottom: 10px;
    font-weight: 500;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    font-size: 1rem;
    padding: 1rem 1.25rem;
  }
`;

export const StyledProductView = styled.div`
  font-family: ${({ theme }) => theme.fontText};
  color: ${({ theme }) => theme.black};

  .product-intro {
    background-color: ${({ theme }) => theme.whiteSmoke};
    padding: 20px 0 50px;
  }

  .product-nav {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 32px;
  }

  .product-back {
    display: inline-flex;
    align-items: center;
    align-self: flex-start;
    gap: 8px;
    padding: 5px 12px;
    border: 1px solid ${({ theme }) => theme.tagBorderColor};
    border-radius: 40px;
    background-color: ${({ theme }) => theme.white};
    color: ${({ theme }) => theme.black};
    font-family: inherit;
    font-size: 14px;
    line-height: 1.4;
    cursor: pointer;
    transition: border-color 0.2s ease-in-out;

    span,
    strong {
      font-size: inherit;
    }

    strong {
      font-weight: 600;
    }

    &:hover {
      border-color: ${({ theme }) => theme.navDark};
    }
  }

  .product-back-icon {
    display: inline-flex;
    flex: none;
    width: 14.33px;
    height: 14.33px;
  }

  .product-breadcrumbs {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 11px;
    font-size: 14px;

    a {
      color: ${({ theme }) => theme.black};
      font-size: inherit;
      text-decoration: underline;

      &:hover {
        color: ${({ theme }) => theme.brand02};
      }
    }
  }

  .product-breadcrumb {
    display: inline-flex;
    align-items: center;
    gap: 11px;
    font-size: inherit;
  }

  .product-breadcrumb-separator {
    display: inline-flex;
    flex: none;
    width: 3.35px;
    height: 5.71px;
  }

  .product-back-icon img,
  .product-breadcrumb-separator img,
  .producer-pill-icon img {
    display: block;
  }

  .product-hero {
    display: flex;
    align-items: flex-start;
    gap: 36px;
  }

  .product-hero-media {
    position: relative;
    flex: none;
    width: 435px;
    aspect-ratio: 1;
    border-radius: 5px;
    overflow: hidden;
  }

  .product-hero-media .product-hero-image,
  .product-hero-media .product-hero-image .ant-image,
  .product-hero-media .product-hero-image img {
    width: 100%;
    height: 100%;
  }

  .product-hero-media .product-hero-image img {
    object-fit: cover;
  }

  .product-hero-media .slick-slider,
  .product-hero-media .slick-list,
  .product-hero-media .slick-track,
  .product-hero-media .slick-slide > div,
  .product-hero-media .gallery-img-container {
    height: 100%;
  }

  .product-hero-media .gallery-img-container .ant-image,
  .product-hero-media .gallery-img-container img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .product-hero-title-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 20px;
    width: 100%;
  }

  .product-hero-qmarks {
    display: flex;
    flex-shrink: 0;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 12px;
    max-width: 50%;
  }

  .product-hero-qmark {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 66px;
    aspect-ratio: ${QUALITY_MARK_ASPECT_RATIO};
  }

  .product-hero-qmark.quality-mark-wide {
    margin-inline: 9px;
  }

  .product-hero-qmark .product-hero-qmark-image,
  .product-hero-qmark .ant-image {
    display: flex;
    width: 100%;
    height: 100%;
  }

  .product-hero-qmark img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .product-hero-zoom {
    position: absolute;
    right: 16px;
    bottom: 16px;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    padding: 8px;
    border: none;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.white};
    box-shadow: 0 3px 8px ${({ theme }) => theme.softSlateBlue};
    cursor: pointer;
  }

  .product-hero-info {
    display: flex;
    flex: 1;
    min-width: 0;
    flex-direction: column;
    gap: 32px;
  }

  .product-hero-heading {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }

  .product-hero-producers {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 5px;
  }

  .producer-pill {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 5px 12px;
    border: 1px solid ${({ theme }) => theme.tagBorderColor};
    border-radius: 40px;
    background-color: ${({ theme }) => theme.white};
    color: ${({ theme }) => theme.black};
    font-size: 14px;
    line-height: 1.4;

    span,
    strong {
      font-size: inherit;
    }

    strong {
      font-weight: 600;
    }
  }

  a.producer-pill:hover {
    border-color: ${({ theme }) => theme.navDark};
    color: ${({ theme }) => theme.black};
  }

  .producer-pill-badge {
    display: inline-flex;
    flex: none;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: 1px solid ${({ theme }) => theme.brand02};
    background-color: ${({ theme }) => theme.white};
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .producer-pill-icon {
    display: inline-flex;
    flex: none;
    width: 9.37px;
    height: 13.33px;

    &.distributor-icon {
      width: 14.5px;
      height: 14.33px;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }

  .product-hero-title {
    min-width: 0;
    margin: 0;
    font-size: 42px;
    font-weight: 700;
    line-height: 1.15;
    color: ${({ theme }) => theme.black};

    span {
      font-size: inherit;
      font-weight: inherit;
    }
  }

  .product-hero-info .desc {
    max-width: 730px;
    font-size: 16px;
    line-height: normal;
    color: ${({ theme }) => theme.black2};

    .show-toggle {
      font-size: inherit;
    }
  }

  .product-hero-options {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 5px;
  }

  .product-hero-options .product-option-tag.ant-tag {
    margin: 0;
    padding: 5px 12px;
    border: 1px solid ${({ theme }) => theme.tagBorderColor};
    border-radius: 40px;
    background-color: ${({ theme }) => theme.optionTagBg};
    color: ${({ theme }) => theme.black};
    font-size: 14px;
    line-height: 1.4;
  }

  .product-hero-price {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .product-hero-price .product-card-price {
    display: flex;
    align-items: flex-end;
    gap: 10px;
  }

  .product-hero-price .product-card-price .price-current {
    font-size: 28px;
    font-weight: 600;
    line-height: 1;
    white-space: nowrap;
    color: ${({ theme }) => theme.navDark};

    &.discounted {
      color: ${({ theme }) => theme.red};
    }

    .price-currency {
      font-size: 28px;
    }

    .price-unit {
      margin-left: 4px;
      font-size: 12px;
      font-weight: 500;
      color: ${({ theme }) => theme.navDark};
    }
  }

  .product-hero-price .product-card-price .price-details {
    display: flex;
    flex-direction: column;
    gap: 2px;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.4;
    white-space: nowrap;

    .price-old {
      color: ${({ theme }) => theme.navDark};
      text-decoration: line-through;
    }

    .price-per-unit {
      color: ${({ theme }) => theme.cardMutedText};
    }
  }

  .product-hero-price .wholesale-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 14px;
    color: ${({ theme }) => theme.cardMutedText};
  }

  .product-hero-cart {
    display: flex;
    align-items: center;

    > div {
      flex: none;
    }
  }

  .product-hero-cart .amount-selector.productView {
    flex: none;
    width: 200px;
    height: 44px;
    border-radius: 40px;
  }

  .product-hero-add-btn.ant-btn {
    width: 200px;
    height: auto;
    padding: 10px 24px;
    border-radius: 40px;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.375;

    .text {
      font-size: inherit;
    }
  }

  .product-details {
    background-color: ${({ theme }) => theme.white};
    padding: 100px 0;
  }

  .product-details-layout {
    display: flex;
    align-items: flex-start;
    gap: 78px;
  }

  .product-tabs {
    flex: 1;
    min-width: 0;
  }

  .product-tabs .ant-tabs-nav {
    margin-bottom: 36px;
  }

  .product-tabs .ant-tabs-nav::before {
    border-bottom-color: ${({ theme }) => theme.tabDivider};
  }

  .product-tabs .ant-tabs-tab {
    padding: 0 0 12px;
    font-size: 16px;
  }

  .product-tabs .ant-tabs-tab + .ant-tabs-tab {
    margin-left: 36px;
  }

  .product-tabs .ant-tabs-tab .ant-tabs-tab-btn {
    color: ${({ theme }) => theme.black};
    font-size: inherit;
  }

  .product-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${({ theme }) => theme.black};
    font-weight: 600;
  }

  .product-tabs .ant-tabs-ink-bar {
    height: 2px;
    background-color: ${({ theme }) => theme.tabActiveBar};
  }

  .product-tab-producer,
  .product-tab-ingredients {
    display: flex;
    flex-direction: column;
    gap: 36px;
    align-items: flex-start;
  }

  .product-tab-ingredients {
    gap: 16px;
    align-items: stretch;
  }

  .product-tab-text,
  .product-tab-producer .desc {
    margin: 0;
    font-size: 16px;
    line-height: 26px;
    color: ${({ theme }) => theme.black};

    .show-toggle {
      font-size: inherit;
    }
  }

  .product-tab-farm-btn.ant-btn {
    height: auto;
    padding: 10px 24px;
    border-radius: 40px;
    background-color: ${({ theme }) => theme.navDark};
    font-size: 16px;
    font-weight: 400;
    line-height: 1.375;

    .text {
      font-size: inherit;
    }

    &:hover {
      background-color: ${({ theme }) => theme.navDark};
      opacity: 0.9;
    }
  }

  .nutrition-table {
    display: flex;
    flex-direction: column;
  }

  .nutrition-row {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    padding: 8px 12px;
    font-size: 16px;
    line-height: 26px;

    &:nth-child(odd) {
      background-color: ${({ theme }) => theme.whiteSmoke};
    }

    span {
      font-size: inherit;
    }
  }

  .product-tab-delivery {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .product-tab-delivery .delivery-wrapper,
  .product-tab-delivery .distribution-points,
  .product-tab-delivery .parcel-terminals {
    display: block;
    width: 100%;
  }

  .product-tab-delivery .delivery-wrapper {
    border-radius: 5px;
    background-color: ${({ theme }) => theme.whiteSmoke};
    overflow: hidden;
  }

  .product-tab-delivery .dropdown-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 20px;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: ${({ theme }) => theme.black};
    cursor: pointer;
    user-select: none;

    > div {
      display: flex;
      flex: none;
      width: 16px;
      height: 16px;
    }

    img {
      display: block;
      width: 16px;
      height: 16px;
    }
  }

  .product-tab-delivery .dropdown-header + .dropdown-content {
    padding: 0 20px 16px;
    font-size: 16px;
    line-height: 26px;
    color: ${({ theme }) => theme.black};

    p {
      margin: 0;
    }

    .address {
      font-size: 14px;
      color: ${({ theme }) => theme.cardMutedText};
    }
  }

  .product-tab-delivery .open-hours-table {
    width: 100%;
    max-width: 420px;
    margin-top: 12px;
    border-spacing: 0;
    border-radius: 5px;
    overflow: hidden;
    font-size: 14px;
    line-height: 22px;

    td {
      padding: 6px 12px;
      background-color: ${({ theme }) => theme.white};
    }

    tr:nth-child(even) td {
      background-color: transparent;
    }

    .td-day {
      width: 130px;
      font-weight: 500;
    }
  }

  .farm-location {
    flex: none;
    width: 358px;
    border-radius: 5px;
    background-color: ${({ theme }) => theme.whiteSmoke};
    overflow: hidden;
  }

  .farm-location-map {
    width: 100%;
    aspect-ratio: 856 / 722;
  }

  .farm-location-body {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    padding: 12px;
  }

  .farm-location-distance {
    margin: 0;
    font-size: 16px;
    line-height: 1.4;
    color: ${({ theme }) => theme.black2};
  }

  .farm-location-hint {
    margin: 0;
    font-size: 14px;
    line-height: 1.4;
    color: ${({ theme }) => theme.black2};
  }

  .farm-location-enable {
    padding: 0;
    border: none;
    background: none;
    color: inherit;
    font-family: inherit;
    font-size: inherit;
    font-weight: 600;
    text-decoration: underline;
    cursor: pointer;

    &:disabled {
      cursor: default;
      opacity: 0.6;
    }
  }

  .farm-location-actions {
    display: flex;
    align-items: center;
    gap: 8px;

    a {
      padding: 8px 16px;
      border-radius: 40px;
      background-color: ${({ theme }) => theme.navDark};
      color: ${({ theme }) => theme.white};
      font-size: 14px;
      line-height: 1.4;

      &:hover {
        color: ${({ theme }) => theme.white};
        opacity: 0.9;
      }
    }
  }

  .farm-products {
    background-color: ${({ theme }) => theme.whiteSmoke};
    padding: 100px 0;
  }

  .farm-products-title {
    margin: 0 0 30px;
    font-size: 42px;
    font-weight: 400;
    line-height: 1.15;
    color: ${({ theme }) => theme.black};

    strong {
      font-size: inherit;
      font-weight: 700;
    }
  }

  .farm-products-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 20px;
  }

  .farm-products .pagination {
    padding-top: 50px;
  }

  .product-lightbox {
    position: fixed;
    inset: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background-color: ${({ theme }) => theme.lightboxOverlay};
  }

  .product-lightbox-inner {
    position: relative;
    width: 100%;
    max-width: 1000px;
    padding: 0 64px 104px;
  }

  .product-lightbox-close {
    position: absolute;
    top: -8px;
    right: 8px;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border: none;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.white};
    color: ${({ theme }) => theme.black};
    cursor: pointer;
  }

  .product-lightbox .product-lightbox-inner .gallery-img-container .ant-image {
    height: calc(100vh - 220px);
  }

  .product-lightbox .product-lightbox-inner .gallery-img-container img {
    border-radius: 5px;
  }

  .product-lightbox .slick-arrow {
    z-index: 2;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.white};
    opacity: 1;

    &::after {
      position: static;
      display: block;
      width: 12px;
      height: 12px;
      margin: 0 auto;
      color: ${({ theme }) => theme.black};
    }

    &.slick-prev {
      left: -56px;
    }

    &.slick-next {
      right: -56px;
    }
  }

  .product-lightbox .slick-dots {
    bottom: -88px;

    > div {
      gap: 40px;
    }

    li {
      height: 64px;
      background-color: transparent;
      text-indent: 0;
    }

    .custom-dot.image-dots {
      top: 0;
      left: -20px;
      width: 64px;
      height: 64px;
      cursor: pointer;

      > div,
      .ant-image {
        width: 100%;
        height: 100%;
      }

      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
        object-fit: cover;
      }
    }
  }

  .banners {
    padding-top: 60px;
    background-color: ${({ theme }) => theme.white};

    .slick-slider {
      margin-bottom: 0;
    }

    .banner-image-wrapper {
      padding: 0;
    }

    .first-banner {
      padding: 0 0 21px;

      .slick-dots-bottom {
        bottom: -20px;
      }
    }

    .second-banner {
      padding: 21px 0 60px;

      .slick-dots-bottom {
        bottom: -32px;
      }
    }
  }

  &.wholesale .product-hero-add-btn.ant-btn {
    background-color: ${({ theme }) => theme.wholesale};

    &:hover {
      background-color: ${({ theme }) => theme.wholesale};
      opacity: 0.9;
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .product-back {
      font-size: 0.875rem;
    }

    .product-breadcrumbs {
      font-size: 0.875rem;
    }

    .product-hero {
      gap: 1.5rem;
    }

    .product-hero-media {
      width: 38%;
      max-width: 435px;
    }

    .product-hero-info {
      gap: 1.5rem;
    }

    .product-hero-heading {
      gap: 1rem;
    }

    .product-hero-title {
      font-size: 2rem;
    }

    .product-hero-qmark {
      width: 3.5rem;
    }

    .product-hero-qmark.quality-mark-wide {
      margin-inline: 0.45rem;
    }

    .producer-pill {
      font-size: 0.875rem;
    }

    .product-hero-info .desc {
      font-size: 1rem;
    }

    .product-hero-options .product-option-tag.ant-tag {
      font-size: 0.875rem;
    }

    .product-hero-price .product-card-price .price-current {
      font-size: 1.75rem;

      .price-currency {
        font-size: 1.75rem;
      }

      .price-unit {
        font-size: 0.75rem;
      }
    }

    .product-hero-price .product-card-price .price-details {
      font-size: 0.75rem;
    }

    .product-hero-price .wholesale-info {
      font-size: 0.875rem;
    }

    .product-hero-add-btn.ant-btn {
      font-size: 1rem;
    }

    .product-details {
      padding: 3.5rem 0;
    }

    .product-details-layout {
      gap: 2.5rem;
    }

    .product-tabs .ant-tabs-tab {
      font-size: 1rem;
    }

    .product-tab-text,
    .product-tab-producer .desc,
    .nutrition-row {
      font-size: 1rem;
      line-height: 1.625rem;
    }

    .product-tab-farm-btn.ant-btn {
      font-size: 1rem;
    }

    .product-tab-delivery .dropdown-header,
    .product-tab-delivery .dropdown-header + .dropdown-content {
      font-size: 1rem;
    }

    .product-tab-delivery .dropdown-header + .dropdown-content .address,
    .product-tab-delivery .open-hours-table {
      font-size: 0.875rem;
    }

    .farm-location {
      width: 300px;
    }

    .farm-location-hint,
    .farm-location-actions a {
      font-size: 0.875rem;
    }

    .farm-location-distance {
      font-size: 1rem;
    }

    .farm-products {
      padding: 3.5rem 0;
    }

    .farm-products-title {
      font-size: 2rem;
    }

    .farm-products-grid {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  @media only screen and (max-width: ${breakpoints.md}px) {
    .product-intro {
      padding: 1rem 0 1.75rem;
    }

    .product-nav {
      gap: 0.75rem;
      margin-bottom: 1.5rem;
    }

    .product-hero {
      flex-direction: column;
      gap: 1.75rem;
    }

    .product-hero-media {
      width: 100%;
      max-width: none;
      aspect-ratio: 414 / 439;
      max-height: 520px;
    }

    .product-hero-info {
      width: 100%;
    }

    .product-hero-title {
      font-size: 1.75rem;
    }

    .product-hero-qmarks {
      gap: 0.5rem;
    }

    .product-hero-qmark {
      width: 2.5rem;
    }

    .product-hero-qmark.quality-mark-wide {
      margin-inline: 0.33rem;
    }

    .product-hero-info .desc {
      max-width: none;
    }

    .product-details-layout {
      flex-direction: column;
      gap: 1.75rem;
    }

    .product-details,
    .farm-products {
      padding: 1.75rem 0;
    }

    .product-tabs,
    .farm-location {
      width: 100%;
    }

    .product-tabs .ant-tabs-nav {
      margin-bottom: 1.25rem;
    }

    .product-tabs .ant-tabs-tab + .ant-tabs-tab {
      margin-left: 1.5rem;
    }

    .product-tab-producer {
      gap: 1.25rem;
    }

    .farm-products-title {
      font-size: 1.75rem;
      margin-bottom: 1.25rem;
    }

    .farm-products-grid {
      grid-template-columns: repeat(2, 1fr);
    }

    .farm-products .pagination {
      padding-top: 1.5rem;
    }

    .banners {
      padding-top: 1.75rem;
    }

    .banners .second-banner {
      padding-bottom: 1.75rem;
    }
  }

  @media only screen and (max-width: ${breakpoints.xs}px) {
    .product-intro .container,
    .product-details .container,
    .farm-products .container,
    .banners .container {
      padding-left: 16px;
      padding-right: 16px;
    }

    .product-breadcrumbs {
      row-gap: 0.375rem;
      column-gap: 0.5rem;
    }

    .product-breadcrumb {
      gap: 0.5rem;
    }

    .product-hero-media {
      width: calc(100% + 32px);
      margin: 0 -16px;
      aspect-ratio: 414 / 439;
      border-radius: 0;
    }

    .product-hero-cart,
    .product-hero-cart > div,
    .product-hero-add-btn.ant-btn,
    .product-hero-cart .amount-selector.productView {
      width: 100%;
    }

    .product-tabs .ant-tabs-nav-list {
      gap: 0;
    }

    .farm-products-grid {
      grid-template-columns: 1fr;
      gap: 0.75rem;
    }

    .product-lightbox {
      padding: 16px;
    }

    .product-lightbox-inner {
      padding: 0 0 80px;
    }

    .product-lightbox-close {
      top: 8px;
    }

    .product-lightbox .slick-arrow {
      display: none;
    }

    .product-lightbox .slick-dots {
      bottom: -68px;

      > div {
        gap: 28px;
      }

      li {
        height: 48px;
      }

      .custom-dot.image-dots {
        left: -12px;
        width: 48px;
        height: 48px;
      }
    }
  }
`;

export const StyledStickyAddToCart = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background-color: ${({ theme }) => theme.white};
  box-shadow: 0px -4px 12px -4px ${({ theme }) => theme.boxShadowColor};
  transform: translateY(110%);
  transition: transform 0.25s ease-in-out;

  &.visible {
    transform: translateY(0);
  }

  .sticky-cart-container {
    max-width: ${({ theme }) => theme.contentWidth};
    margin: 0 auto;
    padding: 16px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
  }

  .sticky-cart-product {
    display: flex;
    align-items: center;
    gap: 20px;
    min-width: 0;

    .ant-image {
      width: 76px;
      height: 76px;
      min-width: 76px;

      img {
        width: 76px;
        height: 76px;
        object-fit: cover;
        border-radius: 8px;
      }
    }
  }

  .sticky-cart-name {
    font-size: 16px;
    font-weight: 600;
    color: ${({ theme }) => theme.black};
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .sticky-cart-actions {
    display: flex;
    align-items: center;
    gap: 50px;

    .price-main {
      width: max-content;
      display: flex;
      flex-direction: column;

      .price-type-container,
      .price-type-second,
      .price-grey,
      .package-price {
        display: flex;
        flex-direction: row;
        align-items: baseline;
        gap: 5px;
      }

      .price-type-wrapper {
        flex-direction: column !important;
      }

      .price {
        font-size: 22px;
        font-weight: 600;
        color: ${({ theme }) => theme.black};
      }

      .type-of-price {
        font-size: 13px;
        color: ${({ theme }) => theme.grey};
      }

      .price-type-second,
      .package-price {
        position: relative;
        font-size: 14px;
        color: ${({ theme }) => theme.grey};
        gap: 8px;
        width: max-content;

        .price {
          font-size: 14px;
          font-weight: 400;
          color: ${({ theme }) => theme.grey};
        }
      }

      .price-type-second::before {
        position: absolute;
        height: 1px;
        width: 110%;
        left: -5px;
        bottom: 10px;
        transform: rotate(-5deg);
        background-color: ${({ theme }) => theme.discountCrossRed};
        content: '';
      }

      .grey-price .price {
        font-size: 22px;
        font-weight: 600;
        color: ${({ theme }) => theme.red};
      }
    }

    .sticky-add-btn {
      height: 42px;
      padding: 0 24px;
    }
  }

  .sticky-cart-actions .amount-selector {
    height: 42px;
  }

  &.wholesale .sticky-cart-actions .sticky-add-btn.ant-btn-primary {
    background-color: ${({ theme }) => theme.wholesale};

    &:hover {
      background-color: ${({ theme }) => theme.wholesale};
      opacity: 0.9;
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    bottom: 100px;
  }

  @media only screen and (max-width: ${breakpoints.sm}px) {
    .sticky-cart-container {
      padding: 10px 15px;
      gap: 10px;
    }

    .sticky-cart-product {
      gap: 10px;

      .ant-image {
        width: 56px;
        height: 56px;
        min-width: 56px;

        img {
          width: 56px;
          height: 56px;
        }
      }
    }

    .sticky-cart-name {
      font-size: 14px;
    }

    .sticky-cart-actions {
      gap: 15px;

      .price-main {
        .price {
          font-size: 18px;
        }

        .grey-price .price {
          font-size: 18px;
        }

        .package-price {
          display: none;
        }
      }

      .sticky-add-btn {
        padding: 0 16px;
      }
    }
  }
`;
